/**
 * Time Spent Filter
 */
function timeSpent() {
    return function(input) {
        var moment = require('moment');
        return moment(input).fromNow();
    };
}

export default angular.module('timeSpent', []).filter('timeSpent', timeSpent).name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/filters/timeSpent.filter.js
 **/